import React from 'react';
import { AMOUNT_DIGITS_AFTER_DOT } from 'common/constants/payment';
import { withCapitalLetter } from 'common/shared/utils/text';
import { MeterEntriesConfirmationMessageStatus, MeterEntriesValidateSuccess } from 'common/model/meterReadings/meterEntriesValidateSuccess';
import { Typography } from 'app/shared/components/typography';


const statusCaptions = {
    warning: 'Превышение среднесуточного расхода более 25%',
    alert: 'Превышение среднесуточного расхода более 50%',
};

const statusClassMap: { [key in MeterEntriesConfirmationMessageStatus]: string } = {
    normal: 'caption-success',
    warning: 'caption-warning',
    alert: 'caption-error',
};

export const MeterEntriesConfirmationMessage: React.FC<{
    entries: { [key: string]: MeterEntriesValidateSuccess },
    isValidate?: boolean;
}> = ({ entries, isValidate, }) => {

    return <>
        <div style={{ marginBottom: 8 }}>
            <Typography variant='body'>{!isValidate ? 'Спасибо, ваши показания приняты!' : ''}</Typography>
        </div>
        {Object.values(entries)?.map(({ serviceName, measure, consumption, amount, mainDebt, status }, index) => {
            return <div key={index}>
                <Typography variant='bodyBold'>{withCapitalLetter(serviceName)}:</Typography>
                <div style={{ marginBottom: 24 }}>
                    Расход по переданным показаниям составил
                    <Typography variant='bodyBold' component='span' className={status && statusClassMap[status]}>
                        &nbsp;{consumption} {measure}&nbsp;
                    </Typography>
                    на&nbsp;сумму
                    <Typography variant='bodyBold' component='span'>
                        &nbsp;{amount.toFixed(AMOUNT_DIGITS_AFTER_DOT)}&nbsp;руб.
                    </Typography>
                    {(status !== 'normal' || !status) && <div>
                        <Typography variant='bodyBold' component='span' className={status && statusClassMap[status]}>
                            {status && statusCaptions[status]}
                        </Typography>
                    </div>}
                </div>
                <div style={{ marginBottom: 24 }}>
                    Итого к оплате по услуге{' '}
                    <Typography variant='bodyBold' component='span'>
                        {(mainDebt ?? 0).toFixed(AMOUNT_DIGITS_AFTER_DOT)} руб.
                    </Typography>
                </div>
            </div>;
        })}
        <Typography variant='body'>
            По всем вопросам обращайтесь в справочную службу по телефону 8 (800) 250-60-06 (бесплатно).
        </Typography>
    </>;
};
